__turbopack_context__.v({
  "chip": "_8EqsZq_chip",
  "container": "_8EqsZq_container",
  "content": "_8EqsZq_content",
  "content-text-outside": "_8EqsZq_content-text-outside",
  "cta": "_8EqsZq_cta",
  "headline": "_8EqsZq_headline",
  "icon": "_8EqsZq_icon",
  "inline": "_8EqsZq_inline",
  "media": "_8EqsZq_media",
  "placeholder": "_8EqsZq_placeholder",
  "plain": "_8EqsZq_plain",
  "slim": "_8EqsZq_slim",
  "teaser": "_8EqsZq_teaser",
  "teaser-bg": "_8EqsZq_teaser-bg",
  "teaser-bg-Aqua": "_8EqsZq_teaser-bg-Aqua",
  "teaser-bg-BackgroundGray": "_8EqsZq_teaser-bg-BackgroundGray",
  "teaser-bg-Berry": "_8EqsZq_teaser-bg-Berry",
  "teaser-bg-Black": "_8EqsZq_teaser-bg-Black",
  "teaser-bg-DarkAqua": "_8EqsZq_teaser-bg-DarkAqua",
  "teaser-bg-DarkBerry": "_8EqsZq_teaser-bg-DarkBerry",
  "teaser-bg-DarkGray": "_8EqsZq_teaser-bg-DarkGray",
  "teaser-bg-DarkGreen": "_8EqsZq_teaser-bg-DarkGreen",
  "teaser-bg-DarkMoss": "_8EqsZq_teaser-bg-DarkMoss",
  "teaser-bg-DarkOrange": "_8EqsZq_teaser-bg-DarkOrange",
  "teaser-bg-DarkRed": "_8EqsZq_teaser-bg-DarkRed",
  "teaser-bg-DarkSmoke": "_8EqsZq_teaser-bg-DarkSmoke",
  "teaser-bg-FadedAqua": "_8EqsZq_teaser-bg-FadedAqua",
  "teaser-bg-FadedBerry": "_8EqsZq_teaser-bg-FadedBerry",
  "teaser-bg-FadedGray": "_8EqsZq_teaser-bg-FadedGray",
  "teaser-bg-FadedGreen": "_8EqsZq_teaser-bg-FadedGreen",
  "teaser-bg-FadedMoss": "_8EqsZq_teaser-bg-FadedMoss",
  "teaser-bg-FadedRed": "_8EqsZq_teaser-bg-FadedRed",
  "teaser-bg-FadedSmoke": "_8EqsZq_teaser-bg-FadedSmoke",
  "teaser-bg-Gray": "_8EqsZq_teaser-bg-Gray",
  "teaser-bg-Green": "_8EqsZq_teaser-bg-Green",
  "teaser-bg-HighlightMossModerate": "_8EqsZq_teaser-bg-HighlightMossModerate",
  "teaser-bg-HighlightMossStrong": "_8EqsZq_teaser-bg-HighlightMossStrong",
  "teaser-bg-HighlightMossSubtle": "_8EqsZq_teaser-bg-HighlightMossSubtle",
  "teaser-bg-LightAqua": "_8EqsZq_teaser-bg-LightAqua",
  "teaser-bg-LightBerry": "_8EqsZq_teaser-bg-LightBerry",
  "teaser-bg-LightGray": "_8EqsZq_teaser-bg-LightGray",
  "teaser-bg-LightGreen": "_8EqsZq_teaser-bg-LightGreen",
  "teaser-bg-LightMoss": "_8EqsZq_teaser-bg-LightMoss",
  "teaser-bg-LightRed": "_8EqsZq_teaser-bg-LightRed",
  "teaser-bg-LightSmoke": "_8EqsZq_teaser-bg-LightSmoke",
  "teaser-bg-Moss": "_8EqsZq_teaser-bg-Moss",
  "teaser-bg-Orange": "_8EqsZq_teaser-bg-Orange",
  "teaser-bg-Red": "_8EqsZq_teaser-bg-Red",
  "teaser-bg-Smoke": "_8EqsZq_teaser-bg-Smoke",
  "teaser-bg-White": "_8EqsZq_teaser-bg-White",
  "text": "_8EqsZq_text",
  "text-cta": "_8EqsZq_text-cta",
  "text-cta-text": "_8EqsZq_text-cta-text",
  "thin": "_8EqsZq_thin",
});
